// Official event logo and brand constants
export const OFFICIAL_LOGO = "/official-logo.png";
// Cropped to content — the original file is a square canvas with the
// actual wordmark filling only a thin centered band (huge blank padding
// baked in), which read as much smaller than the other federation logos
// wherever it was rendered at a matching height.
export const ASIA_AQUATICS_LOGO = "/asia-aquatics-logo-cropped.png";
export const SFI_LOGO = "/sfi-logo.png";
export const KSA_LOGO = "/ksa.png";

// Application builder credit
export const SPORTSLINK_LOGO = "https://customer-assets.emergentagent.com/job_aqua-champs-portal/artifacts/9fojv5qq_IMG-20260512-WA0006.jpg";
export const SPORTSLINK_TAGLINE = "Connect · Compete · Conquer";

export const EVENT_TAGLINE = "United by Water. Driven by Passion.";
export const EVENT_EDITION = "2nd";
export const EVENT_FULL_NAME = "2nd Asian Masters Swimming Championships";
export const EVENT_YEAR = "2026";
export const EVENT_LOCATION = "Bengaluru · India";

// Single source of truth for the numbers repeated across the landing page —
// keep in lockstep with backend/config.py's AVAILABLE_EVENTS / RELAY_EVENTS,
// which is the actual source of truth for what's registerable.
export const INDIVIDUAL_EVENT_COUNT = 15;
export const RELAY_EVENT_COUNT = 4;
export const AGE_CATEGORY_COUNT = 12; // 25-29 ... 75-79, plus 80+
export const COMPETITION_DAYS = 7;

// Staff ID card accent colors — mirrored exactly in
// backend/staff_id_card_pdf.py (STAFF_COLOR_PRESETS) so the downloaded PDF
// matches whatever the admin picked in the live preview.
// "light" is used on the dark back card (borders, header text, emergency/QR
// labels) and needs to pop against it; "dark" is used on white backgrounds
// (role text, ID pill, the white "OFFICIAL EVENT STAFF" box) and needs to
// read clearly there. A true navy for the Official preset would vanish
// against the back card's own dark navy gradient, so it uses a brighter
// blue for "light" and a deep navy only for "dark" (where it's on white).
export const STAFF_COLOR_PRESETS = {
  technical_officials: { label: "Official", light: "#3B82F6", dark: "#1E3A8A" },
  vip: { label: "VIP", light: "#FFD700", dark: "#B8860B" },
  volunteer: { label: "Volunteer", light: "#39FF14", dark: "#16A34A" },
};
export const DEFAULT_STAFF_COLOR = "technical_officials";
export const DEFAULT_CUSTOM_COLOR = "#00F0FF";

// Darkens a hex color by a flat percentage — used to derive the "dark"
// accent (role text, ID pill, back-card header) from a single color the
// admin picks via the color wheel, since a custom pick only gives us one
// hex value where the presets above define a light/dark pair by hand.
// Mirrored in backend/staff_id_card_pdf.py's _darken_hex.
export function darkenHex(hex, amount) {
  const n = parseInt(hex.slice(1), 16);
  const r = Math.max(0, Math.round(((n >> 16) & 255) * (1 - amount)));
  const g = Math.max(0, Math.round(((n >> 8) & 255) * (1 - amount)));
  const b = Math.max(0, Math.round((n & 255) * (1 - amount)));
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}

// Resolves a card's {light, dark} accent pair from either a named preset
// or a custom hex pick — the one function both StaffIdCard's live preview
// and AdminIdGenerator's swatch highlighting call, so they can't drift.
export function resolveStaffColors(colorScheme, customColor) {
  if (colorScheme === "custom" && customColor) {
    return { light: customColor, dark: darkenHex(customColor, 0.35) };
  }
  return STAFF_COLOR_PRESETS[colorScheme] || STAFF_COLOR_PRESETS[DEFAULT_STAFF_COLOR];
}
